export const environment = {
    production: true,
    SKIP_LICENSE_CHECK: false, // never bypass the license check in production
    SKIP_FEED_PUSH: false,     // prod always runs the MediBuddy feed upload
    SUPABASE_URL: 'https://rbllqggnbaizxusvsdnx.supabase.co',
    SUPABASE_KEY: 'sb_publishable_WUZy1xSX19sIPIB6vcky7Q_QJSiZAeZ',
    API_URL: 'https://api.imaxine.in',

    SUPABASE_URL_IMAXINE: 'https://ckprspbmxurzwywfntse.supabase.co',
    SUPABASE_KEY_IMAXINE: 'sb_publishable_wDPZsvX6emPW4EEXKEyxAg_NHvM86Gu',
    ENCRYPTION_KEY: '66mG8oKeeG02wa5bkUjSneUiWwj_jtDDHkJuRh1sJ_c=', // Fernet key (32 bytes base64url) for license encryption/decryption

    // API Configuration
    API_CONFIG: {
        BASE_URL_FUSER: 'https://fuser.medibuddy.in',
        BASE_URL_INTEGRATION: 'https://integration-plus-new.medibuddy.in',
        AUTH_CREDENTIALS: {
            clientId: 33476900,
            sourceId: 33476900,
            username: 'Promiso_user',
            password: 'duNb1nGkNgJOEC56'
        },
        HEADER_CREDENTIALS: {
            username: 'Promiso@User.in',
            password: 'Medi#2025'
        },
        ENTITY_RELATION_ID: 313630
    }
};
